export default {"src":"/_next/static/media/gramax-logo-hp-dark.5fcde3e4.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};